/**
 * Add a new option group
 *
 * @param vars
 * @returns {boolean}
 */
function add_evaluation_question_option_group(vars) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/evaluations/option-groups/add/',
        onOpen: function(elm, popup) {
            validate_evaluation_question_options(elm);

            elm.find('form').ajaxFormSubmit((data) => {
                $('body').doneLoading();

                squde_reload_for_flashes();
                reload_location_if_needed(true);

                if (vars && vars.callback) {
                    vars.callback(data);
                }
                if (!document.closeWindow) open_new_object(view_evaluation_question_option_group, data);
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * View the given option group
 *
 * @param id
 * @returns {boolean}
 */
function view_evaluation_question_option_group(id) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/evaluations/option-groups/view/'+id,
        onOpen: function(elm, popup) {
            validate_evaluation_question_options(elm);

            elm.find('form').ajaxFormSubmit(() => {
                updateObject('evaluation-question-option-group', id);
                $('body').doneLoading();

                squde_reload_for_flashes();
                if (document.closeWindow) popup.close();
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * Delete the given option group
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function delete_evaluation_question_option_group(id, name) {
    name = decodeURI(name);
    custom_delete_with_confirmation('/evaluations/option-groups/delete/' + id,id,"Weet u zeker dat u \""+name+"\" wilt verwijderen? (U kunt hiermee evaluatie-historie corrumperen)",'evaluation-question', () => {
        squde_reload_for_flashes();
        reload_location_if_needed(false);
    });
    return false;
}

function validate_evaluation_question_options(elm) {
    const $ = jQuery.noConflict();
    const validationNotUsableLow = elm.find('.validation-not-usable-low');
    const validationNotUsableHigh = elm.find('.validation-not-usable-high');
    const validationSum = elm.find('.validation-sum');
    const validationOptionsBad = elm.find('.validation-options-bad');
    const validationOptionsGood = elm.find('.validation-options-good');

    elm.find('input[type="number"]').keyup(function() {
        validationNotUsableLow.hide();
        validationNotUsableHigh.hide();
        validationSum.hide();
        validationOptionsBad.hide();
        validationOptionsGood.hide();

        let total = 0;
        let highest = 0;
        elm.find('input[type="number"]').each(function() {
            let value = parseInt($(this).val());
            if (isNaN(value)) {
                value = 0;
            }
            total += value;
            highest = value > highest ? value : highest;
        });

        if (highest < 100 && total < 100) {
            validationNotUsableLow.show();
        } else if (total === 100) {
            validationSum.show();
        } else if (highest < 100) {
            validationOptionsBad.show();
        } else if (total > 100 && highest === 100) {
            validationOptionsGood.show();
        } else {
            validationNotUsableHigh.show();
        }

    });
    elm.find('input[type="number"]:first').trigger('keyup');
}
